import React, { PropTypes } from 'react';
import moment from 'moment';
import injectSheet from 'react-jss';
import { connect } from 'react-redux';

import Comment from '../../contracting/comments/comment';

const styles = {
  dateSplit: {
    color: '#3e5a6d',
    fontSize: '2em',
    padding: '1em 0 1.5em 100px',
  },
};

const ActivityList = (props) => {
  const { className, activities, classes } = props;
  const dateDesc = {};
  const listItems = activities.reduce((data, current) => {
    const dateVal = moment(current.createdAt).format('YYYYMM').toString();
    dateDesc[dateVal] = moment(current.createdAt).format('MMMM YYYY');
    data[dateVal] = [...(data[dateVal] || []), { msgObject: current }];
    return data;
  }, {});
  return (<div className={className}>
  {Object.keys(listItems).sort((a, b) => (~~b - ~~a)).map(dateVal => (<div key={dateVal}>
    <div className={classes.dateSplit}>{dateDesc[dateVal]}</div>
    {listItems[dateVal].map(e => <Comment showContactLink {...e} key={e.key || e.msgObject.messageId}/>)}
  </div>))}
  </div>);
};

ActivityList.propTypes = {
  className: PropTypes.string,
  activities: PropTypes.array,
  classes: PropTypes.object,
  companyId: PropTypes.string,
};
const select = ({ user }) => ({
  companyId: user.getIn(['company', 'companyId']),
});


export default connect(select, {})(injectSheet(styles)(ActivityList));



// WEBPACK FOOTER //
// ./src/app/components/partner-details/activities/activity-list.jsx